import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export type AuthRetryRequestConfig = InternalAxiosRequestConfig & { authRetried?: boolean };

/**
 * Replays a request exactly once after a 401 by silently refreshing the Cognito access
 * token, so a user submitting a long-lived form never loses their work to an expired token.
 * refreshToken must resolve to the fresh JWT, or null if a new sign-in is required.
 */
export const attachAuthRetryInterceptor = (instance: AxiosInstance, refreshToken: () => Promise<string | null>): void => {
    instance.interceptors.response.use(undefined, async error => {
        const config: AuthRetryRequestConfig | undefined = error?.config;

        if (error?.response?.status !== 401 || !config || config.authRetried) {
            throw error;
        }

        const freshToken = await refreshToken();

        if (!freshToken) {
            throw error;
        }

        config.authRetried = true;
        config.headers.Authorization = freshToken;

        return instance.request(config);
    });
};
